import { RoleV1 } from "../types.generated";
import { roleNameV1 } from "./parse";

export function isSuperuserRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "superuser";
}

export function isRegisteredRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "registered";
}

export function isActiveRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "active";
}

export function isActiveMobileRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "activeMobile";
}

export function isArcgisAdminRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "arcgisAdmin";
}

export function isUserAdminRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "userAdmin";
}

export function isSurveyViewerRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "surveyViewer";
}

export function isSurveyorRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "surveyor";
}

export function isSurveyDownloaderRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "surveyDownloader";
}

export function isSurveyAdminRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "surveyAdmin";
}

export function isMapViewerRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "mapViewer";
}

export function isMapDownloaderRoleV1(role: RoleV1): boolean {
  return roleNameV1(role) === "mapDownloader";
}
